import React from 'react';
import { Tooltip, Typography } from '@mui/material';

import { AvatarTooltipProps } from './props';

export const AvatarTooltip: React.FC<AvatarTooltipProps> = (props) => {
  const { title, titleProps, children, ...rest } = props;
  return (
    <Tooltip
      {...rest}
      title={
        <Typography
          variant={'caption'}
          whiteSpace={'pre-wrap'}
          {...titleProps}
          color="white"
        >
          {title}
        </Typography>
      }
      placement={'right'}
    >
      {children}
    </Tooltip>
  );
};
